import FileDocsManager from "../../components/FileDocsManager";
import { documentsService } from "../../services/apiService";

export default function Documents() {
  return (
    <FileDocsManager service={documentsService} moduleCode="documents" noun="Document" />
  );
}
